module.exports = __webpack_public_path__ + "img/HQ-OA-360V05NL.f64277b9.jpg";